export class loginRequest {
  public username: string;
  public password: string | undefined;

  constructor() {
    this.username = '';
    this.password = undefined;
  }
}
